import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ActivityReportExtended, VacationRequestExtended } from '@shared/factories';
import { InfoStateModel             } from '@shared/models';
import { InfoStatesCollectorService } from '@shared/services';

@Component({
  selector:      'info-states',
  templateUrl: './info-states.component.html',
  host: { class: 'am-flex-column text-m', '[class.display-none]': '!loading && !infoStates.length' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InfoStatesComponent implements OnChanges {
  @Input() entry:      ActivityReportExtended | VacationRequestExtended;
  @Input() isInternal: boolean;
  @Input() loading:    boolean;

  infoStates: InfoStateModel[] = [];
  constructor( private infoStatesCollectorService: InfoStatesCollectorService ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.entry?.currentValue?.id !== changes?.entry?.previousValue?.id ||
        changes?.loading?.currentValue   !== changes?.loading?.previousValue) this.collectStates();
  }

  private collectStates(): void {
    this.infoStates = [];
    if (this.loading) this.infoStates = [null];
    else switch (this.entry.constructor) {
      case ActivityReportExtended:
        this.infoStates = this.infoStatesCollectorService.collectActivityReportStates(this.entry as ActivityReportExtended, this.isInternal);
        break;
      case VacationRequestExtended:
        this.infoStates = this.infoStatesCollectorService.collectVacationRequestStates(this.entry as VacationRequestExtended, this.isInternal);
        break;
    }
  }

}
